import type { FaireProductEntity } from "../../entity_types/product";

export const p_9nmydvk8m8: FaireProductEntity = {
  token: "p_9nmydvk8m8",
  type: "product",
  name: "Selma 18K Gold Non-Tarnish CZ Cross Pendant Necklace",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/2430e03e3dc03606aab7ffc411c6511526a1f26df2e0c4d44ce87a8a971571dc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1cd26508308cd5549bdbfcf141764a7c46a98d7d53029ffc2031ef8c08df3a79.jpeg",
    "https://cdn.faire.com/fastly/f82f91768132dea1009b1bc8b84a35a491fdc36066f729df7fbd1b7d4b389701.jpeg",
    "https://cdn.faire.com/fastly/cdcf3fe0b37a76a39c5704937dacd479d5811cee36657568e8fd752671b5e29f.jpeg",
  ],
  priceDollars: 10.96,
  description:
    "18K Gold Non-Tarnish Small Cross Necklace\n18K Gold Plating\nStainless Steel\nCubic Zirconia \nPendant Size (inch): 1 x 0.6\nChain Length (inch): 24\nExtension Length (inch): 2\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:59.730Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
